import React from 'react';
import { Modal } from 'react-bootstrap';
import Add_Portfolio from '../forms/setup/Add_Portfolio';
import Request_Settlement from '../forms/setup/Request_Settlement';

function 
RequestSettlement(props) {
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal-width"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Request Settlement</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Request_Settlement {...props} />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default RequestSettlement;


